<template>
  <div class="activity-wrap">
    <app-header />
    <div class="app">
      <div class="content">
        <p>
          <img
            src="../../assets/images/activity/ddejc/01.png"
            alt=""
            class="img01"
          />
        </p>

        <p class="img02">
          <img src="../../assets/images/activity/ddejc/02.png" alt="" />
        </p>

        <p>
          <img src="../../assets/images/activity/ddejc/03.png" alt="" />
        </p>

        <p>
          <img src="../../assets/images/activity/ddejc/04.png" alt="" />
        </p>

        <div class="advertising">
          <p>
            广告
            风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；
          </p>
          <p>
            所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险，投资有风险，入市需谨慎。
          </p>
        </div>
      </div>

      <div class="footer_zb">
        <div class="footer_zb_content">
          <img
            src="../../assets/images/activity/ddejc/05.png"
            alt=""
            class="img05"
          />
          <a @click="nowOpen()">
            <img
              src="../../assets/images/activity/ddejc/06.png"
              alt=""
              class="img06"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script></script>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader
  },
  data() {
    return {
      s: this.$route.query.s
    };
  },
  created() {
    if(!this.s){
      this.s = "";
    }
  },
  mounted() {},
  methods: {
    nowOpen() {
      var routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: 116,month: 12}})
      let {href} = routerDate;
      window.location.href = href + "?s=" + this.s;
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  min-width: 900px;
  text-align: center;
  background: #dceefc url("../../assets/images/activity/ddejc/bg.png") center
    top no-repeat;
  background-size: auto 787px;
}

.content {
  width: 900px;
  margin: 0 auto;
  padding-bottom: 100px;
}

.img01 {
  width: 890px;
  height: 500px;
  margin-left: -130px;
}

@-webkit-keyframes scale-up-center {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale-up-center {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.img02 {
  margin-top: -70px;
}

.advertising {
  color: #b9b9b9;
  font-size: 12px;
  line-height: 22px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.footer_zb {
  height: 32px;
  background: #e9e9ea;
  border: 2px solid;
  border-image-slice: 1;
  border-width: 2px;
  border-image-source: linear-gradient(to bottom, #ff0205, #fff);
  box-shadow: 0 -6px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
}

.footer_zb .footer_zb_content {
  width: 980px;
  margin: 0 auto;
  position: relative;
}

.img05 {
  position: absolute;
  width: 980px;
  height: 86px;
  left: 50%;
  margin-left: -490px;
  bottom: -32px;
}

.img06 {
  width: 219px;
  height: 74px;
  cursor: pointer;
  position: absolute;
  top: -48px;
  right: 150px;
}

.img06:hover {
  -webkit-animation: scale-up-center 0.5s forwards;
  animation: scale-up-center 0.5s forwards;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity202405143.vue